<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/deal/list" color="blue">取消回上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">新增優惠方案</p>

          <v-text-field
            v-model="form.display_name"
            :rules="[formRules.required]"
            hint="此方案名稱會顯示在消費者的付費頁面，讓使用者方便選擇方案。"
            :persistent-hint="true"
            label="方案名稱"
            outlined
          ></v-text-field>
          <br />
          <v-select
            v-model="form.weekday_type"
            :items="weekdayTypes"
            placeholder="正常/優惠時段"
            outlined>
          </v-select>
          <v-text-field
            type="number"
            min="1"
            v-model.number="form.price"
            :rules="[formRules.amount]"
            label="正常金額"
            outlined
          ></v-text-field>
          <v-text-field
            type="number"
            min="1"
            v-model.number="form.original_price"
            :rules="[formRules.amount]"
            label="優惠時段金額"
            outlined
          ></v-text-field>
          <v-text-field
            type="number"
            min="1"
            v-model.number="form.quantity"
            :rules="[formRules.amount]"
            label="點數"
            outlined
          ></v-text-field>
          <v-text-field
            type="number"
            v-model.number="form.hide_seconds"
            :persistent-hint="true"
            label="輸入後隱藏秒數"
            outlined
          ></v-text-field>
          <v-select
            v-model="form.available"
            :items="mappingAvailable"
            item-text="text"
            item-value="value"
            placeholder="啟用狀態"
            outlined
          ></v-select>
        </v-card-text>
      </v-card>

      <div class="text-center mb-6">
        <v-btn to="/deal/list" color="blue" class="mr-3">取消回上一頁</v-btn>
        <v-btn type="submit" :disabled="!valid" color="orange">確認新增</v-btn>
      </div>
    </v-form>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import dealApi from "@/api/deal";

export default {
  components: {},

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      valid: false,

      form: {
        display_name: "",
        weekday_type: 0,
        quantity: null,
        price: null,
        available: true
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    submit() {
      dealApi
        .create(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
          } else {
            this.$router.push("/deal/list");
          }
        })
        .catch(err => {});
    }
  },

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
